module.exports = __webpack_public_path__ + "img/img4.1f7ea5bf.svg";